module.exports = __webpack_public_path__ + "img/zdyx.ac44b367.jpg";